import { ReactNode } from 'react';
import { SelectableTablePossibleCellsType } from '../../components/SelectableTable/SelectableTable.types';
import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import { promptType, SubText } from '../../components/Prompt/Prompt.component';

export type SampleAssessmentSortBy =
  | 'examiner'
  | 'tasksSolutionSheetId'
  | 'examTaskGroupSolutionScoreId'
  | 'schoolId'
  | 'processType'
  | 'pointSum'
  | 'progress'
  | 'acceptanceStatus'
  | 'updateDate';

export enum AcceptanceStatus {
  None,
  PzwoAccepted,
  KkAccepted,
  CzwoAssessed,
}

export enum ProgressFilter {
  _0_20,
  _20_40,
  _40_60,
  _60_80,
  _80_100,
}

export interface ExamTaskGroupSampleSolution {
  examinerId: string;
  examinerFirstName: string;
  examinerLastName: string;
  examTaskGroupSolutionId: string;
  examTaskGroupSolutionScoreId: string;
  schoolId: string;
  processType: AssessmentSessionProcessTypeId | null;
  pointSum: number;
  progress: number;
  acceptanceStatus: AcceptanceStatus;
  updateDate?: Date;
  isCommentOffPage: boolean;
  isCommentOnImage: boolean;
  isCommentOnCriteria: boolean;
  isScoringAdjusted: boolean;
  examTaskNumbersWithNoAnswer: string[];
}

export interface ExamTaskGroupSampleSolutionsTableItem {
  [key: string]: SelectableTablePossibleCellsType;
  id: string;
  examiner: string;
  examTaskGroupSolutionScoreId: JSX.Element;
  schoolId: JSX.Element;
  processType: JSX.Element;
  pointSum: ReactNode;
  progress: JSX.Element;
  acceptanceStatus: JSX.Element;
  updateDate: JSX.Element;
  actions: JSX.Element;
}

export interface SampleAssessmentSendbackPrompt {
  open: boolean;
  type: promptType;
  mainText?: string;
  subTexts?: SubText[];
}

export interface AdvancedFilterBodyAssessmentExamScoringSchema {
  id: string;
  exactPoints: number | null;
  pointsFrom: number | null;
  pointsTo: number | null;
}

export interface AdvancedFilterBodyAssessment {
  id: string;
  exactPoints: number | null;
  pointsFrom: number | null;
  pointsTo: number | null;
  noAnswer: boolean | null;
  examScoringSchemas: AdvancedFilterBodyAssessmentExamScoringSchema[];
}
